import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LowerCasePipe } from '@angular/common';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatOption } from '@angular/material/autocomplete';
import {
  MAT_SELECT_CONFIG,
  MatSelect,
  MatSelectModule,
} from '@angular/material/select';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { OptionsEnum } from '@app-types/common';
import { EmailSearchOrder } from '@app-types/enums/email.search-order';
import { MailAccountSearchOrder } from '@app-types/enums/MailAccountSearchOrder';
import { UserOrganizationSearchOrder } from '@app-types/enums/UserOrganizationSearchOrder';
import { GroupSearchOrder } from '@app-types/enums/GroupSearchOrder';
import { UserMailAccountSearchOrder } from '@app-types/enums/UserMailAccountSearchOrder';
import { DispatchingRuleSearchOrder } from '@app-types/enums/DispatchingRuleSearchOrder';
import { TagSearchOrder } from '@app-types/enums/tags';
import { TemplateSearchOrder } from '@app-types/enums/TemplateSearchOrder';
import { LoaderComponent } from '@app-components/common/loader/loader.component';
import { ContactsSearchOrder } from '@app-types/enums/contacts';

type SearchOrderType =
  | EmailSearchOrder
  | MailAccountSearchOrder
  | UserOrganizationSearchOrder
  | GroupSearchOrder
  | UserMailAccountSearchOrder
  | DispatchingRuleSearchOrder
  | TagSearchOrder
  | TemplateSearchOrder
  | ContactsSearchOrder
  | 0;

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  imports: [
    TranslateModule,
    LowerCasePipe,
    MatFormField,
    MatIcon,
    MatIconButton,
    MatOption,
    MatSelect,
    MatTooltip,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    LoaderComponent,
  ],
  styleUrls: ['./table-header.component.scss'],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'select-overlay-pane' },
    },
  ],
})
export class TableHeaderComponent {
  @Input() countTotal: number;
  @Input() selectedCount: number;
  @Input() isReloadLoading: boolean;
  @Output() public reloadEventEmitter = new EventEmitter();
  @Output() public searchOrderChangeEventEmitter =
    new EventEmitter<SearchOrderType>();
  @Output() public changeOrderEventEmitter = new EventEmitter();
  @Input() searchOrder?: SearchOrderType;
  @Input() searchOrders: OptionsEnum[];
  @Input() orderDirection?: number;

  constructor() {}

  reload(): void {
    this.reloadEventEmitter.emit();
  }

  searchOrderChange($event: EmailSearchOrder): void {
    this.searchOrderChangeEventEmitter.emit($event);
  }

  changeOrder(): void {
    this.changeOrderEventEmitter && this.changeOrderEventEmitter.emit();
  }
}
